// eslint-disable-next-line eag/no-external-date-time-format-functions -- It is intended to use here
import {formatISO} from 'date-fns';

import {Nullish} from 'shared/web';

export function formatIsoDate(date: string | number | Date | Nullish) {
  if (!date) {
    return null;
  }

  return formatISO(date, {representation: 'date'});
}
